var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTurblattOn = function SvgIconTurblattOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10C14 9.44771 14.4477 9 15 9H25C25.5523 9 26 9.44771 26 10V25.8528L25.2288 26.9453L24.7437 26.5988C24.5092 26.4313 24.2588 26.3024 24 26.2108V21H22C21.4477 21 21 20.5523 21 20C21 19.4477 21.4477 19 22 19H24V11H16V30H20.1575C20.3518 30.577 20.723 31.1003 21.2563 31.4812L21.9826 32H15C14.4477 32 14 31.5523 14 31V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5567 23.183C32.0079 23.5015 32.1155 24.1254 31.797 24.5766L26.757 31.7166C26.6035 31.9341 26.3696 32.0814 26.1072 32.1259C25.8447 32.1704 25.5754 32.1084 25.3588 31.9537L22.4188 29.8537C21.9694 29.5327 21.8653 28.9081 22.1863 28.4587C22.5073 28.0093 23.1318 27.9052 23.5813 28.2262L25.703 29.7417L30.163 23.4233C30.4815 22.9721 31.1055 22.8645 31.5567 23.183Z",
    fill: "#7CBA55"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTurblattOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-turblatt-on.aef05108.svg";
export { ForwardRef as ReactComponent };